import { useEffect, useState } from "react";
import styledCSS from "../../../../../styles/module/others/iconeSuspended.module.css";

export default function IconeLibras() {
  const [vLibrasLoaded, setVLibrasLoaded] = useState(false);

  useEffect(() => {
    const hideVLibrasVisualElements = () => {
      const style = document.createElement("style");
      style.id = "vlibras-hide-visual";
      style.textContent = `
        [vw-access-button] {
          visibility: hidden !important;
          opacity: 0 !important;
          position: absolute !important;
          left: -9999px !important;
          width: 1px !important;
          height: 1px !important;
          overflow: hidden !important;
        }
      `;
      if (!document.querySelector("#vlibras-hide-visual")) {
        document.head.appendChild(style);
      }
    };

    if (window.VLibras) {
      setVLibrasLoaded(true);
      hideVLibrasVisualElements();
      return;
    }

    let vLibrasContainer = document.querySelector("[vw]");
    if (!vLibrasContainer) {
      vLibrasContainer = document.createElement("div");
      vLibrasContainer.setAttribute("vw", "");
      vLibrasContainer.className = "enabled";

      const accessButton = document.createElement("div");
      accessButton.setAttribute("vw-access-button", "");
      accessButton.className = "active";

      const pluginWrapper = document.createElement("div");
      pluginWrapper.setAttribute("vw-plugin-wrapper", "");

      const topWrapper = document.createElement("div");
      topWrapper.className = "vw-plugin-top-wrapper";

      pluginWrapper.appendChild(topWrapper);
      vLibrasContainer.appendChild(accessButton);
      vLibrasContainer.appendChild(pluginWrapper);
      document.body.appendChild(vLibrasContainer);
    }

    hideVLibrasVisualElements();

    if (!document.querySelector('script[src*="vlibras-plugin.js"]')) {
      const script = document.createElement("script");
      script.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
      script.onload = () => {
        if (window.VLibras) {
          new window.VLibras.Widget("https://vlibras.gov.br/app");
          setVLibrasLoaded(true);

          setTimeout(hideVLibrasVisualElements, 500);
        }
      };
      document.head.appendChild(script);
    }
  }, []);

  const handleLibrasClick = () => {
    if (vLibrasLoaded && window.VLibras) {
      try {
        if (window.VLibras.Widget && window.VLibras.Widget.prototype) {
          const vLibrasInstance = document.querySelector("[vw-plugin-wrapper]");
          if (vLibrasInstance) {
            const accessButton = document.querySelector("[vw-access-button]");
            if (accessButton) {
              const clickEvent = new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: true,
              });
              accessButton.dispatchEvent(clickEvent);
            }
          }
        }
      } catch (error) {
        const accessButton = document.querySelector("[vw-access-button]");
        if (accessButton) {
          accessButton.style.visibility = "visible";
          accessButton.style.opacity = "1";
          accessButton.style.position = "static";
          accessButton.style.left = "auto";

          accessButton.click();

          setTimeout(() => {
            accessButton.style.visibility = "hidden";
            accessButton.style.opacity = "0";
            accessButton.style.position = "absolute";
            accessButton.style.left = "-9999px";
          }, 100);
        }
      }
    } else {
      console.warn("VLibras ainda não foi carregado completamente");
    }
  };

  return (
    <>
      <div className={styledCSS.cardLibras} onClick={handleLibrasClick}>
        <svg
          className={styledCSS.icone}
          viewBox="0 0 34 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.4303 1.04618C10.6406 1.12623 10.9161 1.36165 11.0212 1.54058C11.0863 1.66771 11.3968 3.29213 11.7873 5.56163C12.268 8.38201 12.3432 8.83402 12.3432 8.91407C12.3432 9.25779 12.6486 9.68155 12.899 9.68155C13.1794 9.68155 13.3146 9.42259 13.4698 8.5986C13.5399 8.21721 14.1708 5.17082 14.6515 2.8872C14.8418 1.97847 14.9069 1.85605 15.2574 1.76658C15.5429 1.69596 15.9585 1.78542 16.1738 1.96905C16.4492 2.19506 16.4742 2.34573 16.4041 3.40985C16.3691 3.91836 16.334 4.41275 16.324 4.50222C16.314 4.59168 16.2789 5.06723 16.2489 5.56163C16.2189 6.05131 16.1838 6.55982 16.1738 6.69166C16.1087 7.28964 15.9985 9.5968 15.9985 10.3219V11.1271L15.613 11.2683C15.1973 11.419 14.0957 11.7627 13.3947 11.9605C13.1594 12.0217 12.7688 12.0923 12.5184 12.1064C11.9676 12.1441 11.5069 12.2383 11.2315 12.3701C10.896 12.5302 10.5205 12.9022 10.3602 13.227C10.23 13.486 10.215 13.5708 10.215 13.9898C10.215 14.4277 10.225 14.4842 10.3753 14.7667C10.7608 15.5012 11.6071 16.0757 12.7137 16.3488C13.1193 16.4524 14.3862 16.4947 15.3776 16.4429C15.8032 16.4194 16.1638 16.4147 16.1788 16.4288C16.2239 16.4712 15.4828 17.8319 15.1923 18.2369C14.6515 18.9902 12.924 21.1985 12.3832 21.8295L12.243 21.9942L11.4268 21.9801C10.9311 21.9754 10.4203 21.9942 10.1149 22.0319C9.53903 22.1073 9.36878 22.079 8.88807 21.8059C8.58763 21.6317 8.04683 21.1279 7.80147 20.7936C7.16554 19.9131 6.58969 18.1192 6.13402 15.5907C5.97379 14.7008 5.85361 14.3618 5.44801 13.6367C5.18763 13.1658 4.9623 12.8409 3.4651 10.7645C2.49867 9.42729 1.57732 7.93941 1.57732 7.72282C1.57732 7.58157 1.74256 7.3226 1.90781 7.20489C2.09809 7.06363 2.46362 7.04009 2.64389 7.1531C2.83417 7.27081 3.0595 7.50623 4.24624 8.85286C6.48954 11.3907 6.48954 11.3907 6.90015 11.5179C7.16053 11.5932 7.31075 11.5508 7.38586 11.3719C7.49602 11.1224 7.3458 10.6421 6.71487 9.2672C6.39941 8.57506 6.06392 7.84995 5.96878 7.6569C5.87364 7.46386 5.74845 7.2096 5.69337 7.09188C5.63829 6.97417 5.35788 6.3809 5.06745 5.7688C4.33137 4.21029 4.24124 3.91836 4.4165 3.57464C4.51664 3.37689 4.91723 3.18384 5.2377 3.18384C5.6433 3.18384 5.69337 3.25918 7.71134 6.97417C8.76789 8.91878 9.11841 9.52146 9.3187 9.71451C9.55405 9.94523 9.6542 9.96406 9.76937 9.79926C9.84448 9.69097 9.84949 9.57797 9.82445 8.91407C9.78439 8.00533 9.66421 6.16431 9.56407 5.02015C9.40884 3.24034 9.3838 2.95783 9.33873 2.54819C9.22356 1.54528 9.28866 1.33811 9.78439 1.09798C10.0999 0.952015 10.175 0.942598 10.4303 1.04618Z"
            fill="white"
          />
          <path
            d="M24.5211 10.0865C24.9216 10.1807 25.0068 10.2372 25.823 10.9811C26.5741 11.6638 27.3502 12.1865 28.1764 12.5679C28.577 12.7515 28.6622 12.8127 28.7974 13.0105C29.1328 13.5096 29.263 13.9239 29.3031 14.6255C29.3381 15.2329 29.258 15.6943 28.9426 16.7207C28.5971 17.8461 28.3267 18.5335 27.6407 19.9696C27.0398 21.2315 27.0097 21.481 26.9947 25.0312C26.9797 27.8516 26.9346 28.6615 26.7844 28.8828C26.6742 29.0429 26.2887 29.1888 26.0784 29.1606C25.6077 29.0852 25.5025 28.8733 25.3623 27.6915C25.3072 27.1971 25.2271 26.5191 25.187 26.1848C25.147 25.8458 25.0819 25.2525 25.0368 24.8664C24.8766 23.3785 24.8065 23.129 24.501 22.8889C24.3308 22.7523 24.2256 22.7429 24.0804 22.8418C23.785 23.0301 23.6398 23.6469 22.8786 27.9034C22.5031 30.0081 22.453 30.2247 22.2828 30.5402C22.1075 30.865 21.9122 30.978 21.5817 30.9357C21.051 30.8745 20.8056 30.6437 20.8056 30.2059C20.8056 30.0128 20.9358 28.8639 21.3614 25.3608C21.5467 23.8117 21.5717 23.1761 21.4415 22.9924C21.3364 22.8371 21.1962 22.8512 21.0209 23.0348C20.7856 23.2797 18.1417 27.6162 17.1502 29.3866C16.8448 29.9375 16.7446 30.0458 16.5093 30.1211C16.2689 30.1964 15.8233 30.1541 15.658 30.0411C15.4527 29.8998 15.2775 29.5278 15.2775 29.2453C15.2825 29.0052 15.2925 28.9816 16.4642 26.5379C16.8848 25.6527 16.98 25.4644 17.5007 24.3956C17.9113 23.5575 18.0465 23.2844 18.4722 22.4274C18.5623 22.2438 18.6574 22.0178 18.6775 21.933C18.7275 21.6976 18.6675 21.4622 18.5272 21.3774C18.2518 21.2079 18.2568 21.2032 15.2875 24.0189C13.7202 25.5021 12.4283 26.6933 12.3432 26.7263C11.8224 26.9287 11.1264 26.3637 11.2115 25.8175C11.2515 25.568 11.3116 25.4879 12.5885 23.9389C15.4227 20.5111 16.5644 19.0091 17.1502 17.9167C18.1066 16.1463 18.1667 15.3694 17.3806 15.0492C17.0551 14.9127 16.6395 14.8986 15.7582 14.9739C14.6966 15.0728 13.6551 15.0728 13.2144 14.9739C12.5585 14.8326 11.9275 14.4889 11.7773 14.1876C11.6622 13.9663 11.6722 13.8862 11.8124 13.7544C11.9726 13.6037 12.223 13.5472 12.8439 13.5143C13.2895 13.4907 13.5049 13.4436 14.246 13.227C15.7131 12.8033 16.319 12.5726 17.7511 11.8993C18.5072 11.5461 19.2533 11.2024 19.4035 11.1459C19.5538 11.0847 19.7941 10.9858 19.9343 10.9246C20.9458 10.4914 22.2277 10.0724 22.7384 10.0159C23.2542 9.95465 24.1305 9.9876 24.5211 10.0865Z"
            fill="white"
          />
          <path
            d="M30.1443 12.4878C30.3496 12.5631 30.7402 13.5896 30.8203 14.2723C30.9105 14.9927 30.7652 16.2028 30.5449 16.603C30.4548 16.7678 30.3246 16.8149 30.1493 16.7396C29.9891 16.6689 29.944 16.5277 30.0191 16.3441C30.1043 16.1369 30.2094 15.5436 30.2445 15.0445C30.2946 14.4089 30.1343 13.6178 29.8389 13.0622C29.7738 12.9398 29.7187 12.7892 29.7187 12.7232C29.7187 12.5161 29.919 12.4078 30.1443 12.4878Z"
            fill="white"
          />
          <path
            d="M31.8819 12.8362C32.2074 13.0764 32.4577 14.2676 32.3676 15.1528C32.3125 15.6425 32.1122 16.4665 31.962 16.8008C31.8468 17.055 31.6515 17.1633 31.4763 17.0786C31.311 16.9938 31.301 16.829 31.4362 16.4994C31.6215 16.071 31.7267 15.5248 31.7567 14.8986C31.7867 14.2865 31.7417 13.9663 31.5364 13.3589L31.4012 12.9681L31.5364 12.8551C31.7066 12.7185 31.7267 12.7185 31.8819 12.8362Z"
            fill="white"
          />
          <path
            d="M5.97379 20.4499C6.03387 20.4969 6.12401 20.6429 6.17408 20.7748C6.22916 20.9066 6.37938 21.1891 6.51458 21.401C7.03034 22.2203 7.60118 22.757 8.3673 23.1525C8.76289 23.3597 8.84301 23.4633 8.71782 23.6422C8.58763 23.8259 8.45744 23.8306 8.12194 23.6705C7.12047 23.1902 6.14404 22.1638 5.65331 21.0714C5.49308 20.7041 5.48807 20.5676 5.63328 20.4546C5.77349 20.3463 5.84359 20.3463 5.97379 20.4499Z"
            fill="white"
          />
          <path
            d="M4.74698 20.9678C4.78704 21.0149 4.85214 21.1561 4.88218 21.288C4.95729 21.5799 5.34786 22.3662 5.60825 22.7476C5.86362 23.1196 6.43446 23.6516 6.82504 23.8729C7.17555 24.0801 7.24566 24.2072 7.11546 24.3956C6.98527 24.5792 6.80501 24.5462 6.3944 24.2779C5.52813 23.7081 4.88719 22.903 4.44153 21.8295C4.23623 21.3398 4.20619 21.142 4.30633 21.0008C4.40147 20.8642 4.6268 20.8501 4.74698 20.9678Z"
            fill="white"
          />
        </svg>
        Libras
      </div>
    </>
  );
}
